import { Run } from "@quantizr-engineering/common/types/run";
import { Show } from "@quantizr-engineering/common/types/show";
import apiClient from './apiClient';
import { toast } from 'sonner';

export interface AiRequest {
  question: string;
  context: string;
}

export const useAiService = () => {
  const generateQzResponse = async (question: string, run: Run | null, shows: Show[]): Promise<string> => {
    const slimmedDownShowsJson = shows?.map(show => { return {...show, files: []} }) ?? []
    try {
      const request: AiRequest = {
        question,
        context: JSON.stringify({ ...run, slimmedDownShowsJson })
      };
      
      const response = await apiClient.post('/ai', request);
      return response.data;
    } catch (error) {
      toast.error('Failed to generate AI response');
      throw new Error('AI service error');
    }
  };

  return { generateQzResponse };
};
